import { formatDistance } from 'date-fns';

const timeAgo = (date) => {
  return `${formatDistance(date, new Date(), {
    addSuffix: false,
  })}, ${date.toLocaleTimeString(undefined, { hour: 'numeric', minute: 'numeric', hour12: true })}`;
};

export default timeAgo;
